<template>
  <div class="card card-shadow">
    <div class="card-header">
      <h1 class="h4">{{ translate('previews.subtest-attempt.title') }}</h1>
    </div>
    <div class="card-body p-4">
      <div class="row">
        <div class="col-lg-12 text-center">
          <img height="200px" :src="subtest.image_path" class="border shadow"
               alt="subtest_cover">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <ul style="list-style-type: none; padding-inline-start: 0" class="mb-0">
            <li>
              {{ translate('previews.info.test-type') }}:
              <span class="font-weight-bold">{{ subtest.test_type.title }}</span>
            </li>
            <li>
              {{ translate('previews.info.subtest-type') }}:
              <span class="font-weight-bold">{{ subtest.subtest_type.title_de }}</span>
            </li>
            <li>
              {{ translate('previews.info.test-variation') }}:
              <span class="font-weight-bold">{{ subtest.test_variation.title_de }}</span>
            </li>
            <li>
              {{ translate('previews.subtest.info.attempts') }}:
              <span class="font-weight-bold">{{ subtest.subtest_attempts_count }}</span>
            </li>
            <!--                        <li v-if="subtestFilePath">-->
            <!--                            <a :href="subtestFilePath" download>-->
            <!--                                <span class="fa fa-download mr-1"></span>{{ translate('previews.info.download-subtest') }}-->
            <!--                            </a>-->
            <!--                        </li>-->
          </ul>

          <div v-if="['writing', 'complete'].includes(subtest.subtest_type.name)">
            <div class="card mt-2">
              <div class="card-body">
                <img class="card-img-top mb-2" style="width: 40px" src="/images/icon1.svg" alt="reading">
                <h5 class="card-title">Reading Files</h5>
                <h6 class="card-subtitle mb-2 text-muted">Here you can download/upload speaking files</h6>

                <ul class="list-group list-group-flush" style="font-size: 16px">
                  <li class="list-group-item">
                    Current Files:

                    <span v-for="file in subtest.reading_files" class="mb-0">
                        <a :href="file.url"
                           :download="file.original_name">
                            <i v-if="file.mime_type === 'application/pdf'"
                               class="fas fa-file-pdf text-danger"></i>
                            <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                            {{ file.original_name }}

                            <i class="fa fa-download"></i>
                        </a>
                        <br>
                    </span>
                  </li>
                  <li class="list-group-item">
                    Replace PDF files:

                    <form role="form" class="upload-file-form">
                      <input ref="reading_file"
                             type="file"
                             name="reading_file"
                             @change="uploadFile('reading')"
                             :disabled="uploadReadingFileForm.busy">
                    </form>
                  </li>
                </ul>
              </div>
            </div>

            <div class="card mt-2">
              <div class="card-body">
                <img class="card-img-top mb-2" style="width: 40px" src="/images/icon2.svg" alt="listening">
                <h5 class="card-title">Listening Files</h5>
                <h6 class="card-subtitle mb-2 text-muted">Here you can download/upload speaking files</h6>

                <ul class="list-group list-group-flush" style="font-size: 16px">
                  <li class="list-group-item">
                    Current Files:

                    <span v-for="file in subtest.listening_files" class="mb-0">
                        <a :href="file.url"
                           :download="file.original_name">
                            <i v-if="file.mime_type === 'application/pdf'"
                               class="fas fa-file-pdf text-danger"></i>
                            <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                            {{ file.original_name }}

                            <i class="fa fa-download"></i>
                        </a>
                        <br>
                    </span>
                  </li>
                  <li class="list-group-item">
                    Replace PDF files:

                    <form role="form" class="upload-file-form">
                      <input ref="listening_file"
                             type="file"
                             name="listening_file"
                             @change="uploadFile('listening')"
                             :disabled="uploadListeningFileForm.busy">
                    </form>
                  </li>

                  <li class="list-group-item">
                    Replace MP3 files:

                    <form role="form" class="upload-file-form">
                      <input ref="listening_mp3_file"
                             type="file"
                             name="listening_mp3_file"
                             @change="uploadFile('listening_mp3')"
                             :disabled="uploadListeningMp3FileForm.busy">
                    </form>
                  </li>
                </ul>
              </div>
            </div>

            <div class="card mt-2">
              <div class="card-body">
                <img class="card-img-top mb-2" style="width: 40px" src="/images/icon3.svg" alt="writing">
                <h5 class="card-title">Writing Files</h5>
                <h6 class="card-subtitle mb-2 text-muted">Here you can download/upload speaking files</h6>

                <ul class="list-group list-group-flush" style="font-size: 16px">
                  <li class="list-group-item">
                    Current Files:

                    <span v-for="file in subtest.writing_files" class="mb-0">
                        <a :href="file.url"
                           :download="file.original_name">
                            <i v-if="file.mime_type === 'application/pdf'"
                               class="fas fa-file-pdf text-danger"></i>
                            <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                            {{ file.original_name }}

                            <i class="fa fa-download"></i>
                        </a>
                        <br>
                    </span>
                  </li>
                  <li class="list-group-item">
                    Replace PDF files:

                    <form role="form" class="upload-file-form">
                      <input ref="writing_file"
                             type="file"
                             name="writing_file"
                             @change="uploadFile('writing')"
                             :disabled="uploadWritingFileForm.busy">
                    </form>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="card mt-2" v-if="['speaking', 'complete'].includes(subtest.subtest_type.name)">
            <div class="card-body">
              <img class="card-img-top mb-2" style="width: 40px" src="/images/icon4.svg" alt="speaking">
              <h5 class="card-title">Speaking Files</h5>
              <h6 class="card-subtitle mb-2 text-muted">Here you can download/upload speaking files</h6>
              <ul class="list-group list-group-flush" style="font-size: 16px">
                <li class="list-group-item">
                  Current Files:

                  <span v-for="file in subtest.speaking_files" class="mb-0">
                      <a :href="file.url"
                         :download="file.original_name">
                          <i v-if="file.mime_type === 'application/pdf'"
                             class="fas fa-file-pdf text-danger"></i>
                          <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                          {{ file.original_name }}

                          <i class="fa fa-download"></i>
                      </a>
                      <br>
                  </span>
                </li>

                <li class="list-group-item">
                  Replace PDF files:

                  <form role="form" class="upload-file-form">
                    <input ref="speaking_file"
                           type="file"
                           name="speaking_file"
                           @change="uploadFile('speaking')"
                           :disabled="uploadSpeakingFileForm.busy">
                  </form>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-12 mt-2">
          <button
            class="btn btn-block btn-primary text-white"
            @click="showEditSubtestModal">
            <span class="fa fa-edit mr-1"></span>{{ translate('previews.buttons.edit') }}
          </button>
        </div>

        <div class="col-md-12 mt-2">
          <button
            class="btn btn-block btn-danger text-white"
            @click="showDeleteSubtestModal">
            <span class="fa fa-trash-alt mr-1"></span>{{ translate('previews.buttons.delete') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['subtest'],

  data () {
    return {
      uploadReadingFileForm: new AppForm({}),
      uploadListeningFileForm: new AppForm({}),
      uploadListeningMp3FileForm: new AppForm({}),
      uploadWritingFileForm: new AppForm({}),
      uploadSpeakingFileForm: new AppForm({}),
    };
  },

  computed: {
    subtestFilePath () {
      return this.subtest.files.length > 0 ? this.subtest.files[0].url : null;
    }
  },

  methods: {
    showEditSubtestModal () {
      this.$parent.$emit('showEditSubtestModal');
    },

    showDeleteSubtestModal () {
      this.$parent.$emit('showDeleteSubtestModal');
    },

    uploadFile (type) {
      if (!this.$refs[type + '_file'].files.length) {
        return;
      }

      let self = this;
      let uploadFileForm;

      if (type === 'reading') {
        uploadFileForm = this.uploadReadingFileForm;
      } else if (type === 'listening') {
        uploadFileForm = this.uploadListeningFileForm;
      } else if (type === 'writing') {
        uploadFileForm = this.uploadWritingFileForm;
      } else if (type === 'listening_mp3') {
        uploadFileForm = this.uploadListeningMp3FileForm;
      } else if (type === 'speaking') {
        uploadFileForm = this.uploadSpeakingFileForm;
      } else {
        return;
      }

      uploadFileForm.startProcessing();

      // We need to gather a fresh FormData instance with the document file appended to
      // the data so we can POST it up to the server.
      let form = new FormData();
      form.append('file', this.$refs[type + '_file'].files[0]);
      form.append('subtest_id', this.subtest.id);
      form.append('subtest_type', type !== 'listening_mp3' ? type : 'listening');

      axios.post('/files', form)
        .then((response) => {
          self.$refs[type + '_file'].value = '';
          uploadFileForm.finishProcessing();
          self.$parent.$emit('getSubtest', self.subtest.id);
        }, (error) => {
          uploadFileForm.setErrors(error.response.data.errors);
        });
    },

  }
};
</script>

<style>
/*.osd-cover-page .block-style {*/
/*}*/

/*.block-style {*/
/*    height: 100%;*/
/*    display: inline;*/
/*}*/

/*.block-style h4 {*/
/*    margin-top: 0*/
/*}*/

/*.block-style-img svg {*/
/*    display: block;*/
/*    height: 39px;*/
/*    width: 40px;*/
/*}*/

/*.block-style-img svg path {*/
/*    fill: #000;*/
/*}*/

/*.block-style-img {*/
/*    padding: 0;*/
/*    -webkit-box-shadow: 0 0 5px 0 rgba(59, 59, 59, .35);*/
/*    -moz-box-shadow: 0 0 5px 0 rgba(59, 59, 59, .35);*/
/*    box-shadow: 0 0 5px 0 rgba(59, 59, 59, .35);*/
/*}*/

/*@media (max-width: 1000px) {*/
/*    .block-style-img {*/
/*        width: 50px;*/
/*        padding: 0;*/
/*    }*/

/*    .block-style2 .block-style-content {*/
/*        margin-left: 70px;*/
/*    }*/
/*}*/

/*.block-style {*/
/*    border: 1px solid #E2E2E2;*/
/*    padding: 27px;*/
/*    margin: 30px 0 0;*/
/*    overflow: hidden;*/
/*    font-size: 12px;*/
/*    line-height: 20px;*/
/*    position: relative;*/
/*}*/

/*.block-style h4 {*/
/*    font-size: 18px;*/
/*    font-weight: 700;*/
/*}*/

/*.block-style b {*/
/*    font-weight: 500;*/
/*}*/

/*.block-style-content {*/
/*    margin-left: 64px;*/
/*}*/

/*.block-style-img {*/
/*    width: 39px;*/
/*    float: left;*/
/*}*/

/*.block-style-img img {*/
/*    display: block;*/
/*    height: auto;*/
/*    width: 100%;*/
/*}*/
</style>
